<template>
  <div>
    <v-card>
      <v-card-text>
        <v-tabs
          :key="tabsKey"
          v-model="tab"
          class="mb-8"
          background-color="transparent"
          flat
          fixed-tabs
          next-icon="mdi-chevron-right"
          prev-icon="mdi-chevron-left"
          show-arrows
          @change="handleTabChange"
        >
          <v-tab
            v-for="item in tabs"
            :key="item.value"
            :href="item.value"
          >
            {{ item.title }}
          </v-tab>
        </v-tabs>

        <slot />
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <portal-target name="faq-settings-layout-submit" />
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import Layout from '@/components/shared/TheLayout';
import TabsLayout from '@/components/faq/TabsLayout';
import i18n from '@/plugins/vue-i18n';

export default {
  provide() {
    return {
      settingsLayout: this
    }
  },

 layout: (h, page) => h(Layout, {
    props: {
      noWrappingContainer: true,
      pageTitle: page.data.props.faq.default_translation.name
    }
  }, [h(TabsLayout, {
    props: {
      activeTab: 'settings',
      faq: page.data.props.faq,
    }
  }, [page])]),

  props: {
    faq: {
      type: Object,
      required: true
    },
    activeTab: {
      type: String,
      required: false,
      default: null
    },
    hideComponentSwitch: {
      type: Boolean,
    }
  },

  data() {
    return {
      tab: this.activeTab,
      tabsKey: 0,
    }
  },

  computed: {
    tabs() {
      return [
        {
          title: i18n.t('General'),
          value: '#general',
          href: this.route('faq-settings.general', this.faq.id)
        },
        {
          title: i18n.t('Embed on page'),
          value: '#embed',
          href: this.route('faq-settings.embed', this.faq.id)
        },
        {
          title: i18n.t('Use as widget'),
          value: '#widget',
          href: this.route('faq-settings.widget', this.faq.id)
        },
        {
          title: i18n.t('FAQ Portal'),
          value: '#portal',
          href: this.route('faq-settings.portal', this.faq.id)
        },
      ]
    },
  },

  watch: {
    activeTab: function(value) {
      this.tab = value;
    }
  },

  created() {
    window.eventBus.$on('faq.settings-layout:set-tab', tabName => {
      this.$nextTick(() => {
        this.tab = tabName;
      });
    });

    window.eventBus.$on('faq.settings-layout:toggle-live-preview', () => {
      this.tabsKey++;
    });
  },

  methods: {
    handleTabChange(value) {
      const tab = this.tabs.find(tab => tab.value === `#${value}`);

      this.$inertia.visit(tab.href, {
        onSuccess: () => {
          this.$forceUpdate();
        }
      });
    },
  }
}
</script>
